export default __webpack_public_path__ + "static/media/circle-flags_uk.6d2b8c8a.svg";